module.exports = __webpack_public_path__ + "9adf86db052fa5c73e5b164bb594c504.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/golf-channel.jpg
 ** module id = 442
 ** module chunks = 0
 **/